import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { Buffer } from "buffer";

import ElementPlus from "element-plus";
import "@/utils/rem"; // 引入rem适配
// main.ts 或任意入口
import * as Cesium from "cesium";
import "cesium/Build/Cesium/Widgets/widgets.css"; // 样式也要引
import "element-plus/dist/index.css";
import zhCn from "element-plus/es/locale/lang/zh-cn";
// 引入全局css
import "./assets/scss/style.scss";
// 引入图表（所有图标见 icon 目录下的 demo_index.html）
import "./assets/icon/iconfont.css";
//引入自定义的element样式
import "./assets/scss/element.scss";
// 引入 全局注册组件
import PublicComponent from "@/components/componentInstall";

// out_js.js 依赖浏览器全局 Buffer
(globalThis as typeof globalThis & { Buffer?: typeof Buffer }).Buffer = Buffer;

const app = createApp(App);
app.use(PublicComponent);

app.use(store);
app.use(router);
app.use(ElementPlus, { locale: zhCn });

app.mount("#app");
